import React, { useContext, useEffect } from 'react';
import { Button, ButtonGroup, Paper, Stack } from '@mui/material';

import { RgbControl } from 'components/light/AccordionDetailsContent/ComponentWrapper/RgbControl';
import { TempControl } from 'components/light/AccordionDetailsContent/ComponentWrapper/TempControl';
import { LightState } from 'types/aspen/state';
import { LeafStateContext } from 'context/state/leaf';

export const ControlPanelWrapper = () => {
  const { leaf } = useContext(LeafStateContext);
  const leafState = leaf.state as LightState;
  const colorType = leafState.color?.colorType;
  const [displayMode, setDisplayMode] = React.useState<'rgb' | 'temperature'>(colorType || 'rgb');

  const initialRender = React.useRef(true);
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    }
  }, []);

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{
        padding: 2,
        borderRadius: 1,
        backgroundColor: 'transparent',
        color: '#333',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 2,
          borderRadius: 1,
          backgroundColor: 'transparent',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ButtonGroup
          variant="contained"
          aria-label="Color control mode selection"
          role="radiogroup"
          aria-describedby="color-mode-desc"
        >
          <Button
            disabled={displayMode === 'rgb'}
            onClick={() => setDisplayMode('rgb')}
            role="radio"
            aria-checked={displayMode === 'rgb'}
            aria-label="RGB color picker mode"
          >
            RGB
          </Button>
          <Button
            disabled={displayMode === 'temperature'}
            onClick={() => setDisplayMode('temperature')}
            role="radio"
            aria-checked={displayMode === 'temperature'}
            aria-label="Temperature color picker mode"
          >
            Temperature
          </Button>
        </ButtonGroup>
        <div id="color-mode-desc" style={{ display: 'none' }}>
          Choose between RGB and temperature color control modes
        </div>

        <Stack spacing={2} sx={{ marginTop: 4 }}>
          {displayMode === 'rgb' ? (
            <RgbControl initialRender={initialRender.current} />
          ) : (
            <TempControl initialRender={initialRender.current} />
          )}
        </Stack>
      </Paper>
    </Stack>
  );
};
